import { Component } from '@angular/core';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatDialogRef, MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-confirm-status-dialog',
  templateUrl: './confirm-status-dialog.component.html',
  styleUrls: ['./confirm-status-dialog.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogContent, MatIcon],
})
export class ConfirmStatusDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConfirmStatusDialogComponent>) {}

  onClose(result: boolean) {
    this.dialogRef.close(result);
  }
}
